// actions関数名の定数一覧
const ACTION_TYPE = {
  LOGIN_CLEAR: 'login_clear', // ログイン情報クリア
  LOGIN_AUTH: 'login_auth', // ログイン認証情報設定
  LOGIN_BEFORE_INIT: 'login_before_init', // ログイン前初期処理
  LOGIN_INFO: 'login_info', // ログイン
  TOP_REDIRECT: 'top_redirect', // TOP画面遷移情報設定
  TOP_REDIRECT_CLEAR: 'top_redirect_clear', // TOP画面遷移情報設定
  LOGOUT: 'logout', // ログアウト
  MENU_SET: 'menu_set', // メニュー情報設定
  DOWNLOAD_SET: 'download_set', // ダウンロード検索情報設定
  DOWNLOAD_CLEAR: 'download_clear', // ダウンロード検索情報クリア
  DOWNLOAD_ERROR_SET: 'download_error_set', // ダウンロードエラー情報設定
  LANGCHANGE_SET: 'language_set', // 言語切り替え
  HEADER_CLEAR: 'header_clear', // ヘッダー情報クリア
  OTHER_SET: 'other_set', // 他画面情報の設定
} as const

type ACTION_TYPE = typeof ACTION_TYPE[keyof typeof ACTION_TYPE]
export default ACTION_TYPE
